import React from 'react'

const RateAiIcon = (props) => {
  const { classes } = props
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M15.8553 1.93671C16.8317 0.960402 18.4146 0.960402 19.3909 1.93671L21.4901 4.03594C22.4664 5.01225 22.4664 6.59516 21.4901 7.57147L20.6479 8.41368L15.0131 2.77893L15.8553 1.93671Z"
        fill="#00B2AD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.306 3.48603L19.9408 9.12079L10.892 18.1696L10.887 18.1714L10.8906 18.1814L5.15464 20.2523C4.33286 20.549 3.52742 20.0941 3.24672 19.3908C3.10527 19.0658 3.07692 18.6841 3.21385 18.2979L4.16406 15.618L4.17695 15.6308L5.24591 12.5677L5.2572 12.5349L14.306 3.48603ZM6.03106 13.3528L4.9621 16.416L7.05067 18.5046L10.0867 17.4085L6.03106 13.3528Z"
        fill="#00B2AD"
      />
      <path
        d="M4.1748 0.768945C4.1748 0.437574 3.95095 0.168945 3.6748 0.168945C3.39866 0.168945 3.1748 0.437574 3.1748 0.768945V2.66895H1.3373C1.00593 2.66895 0.737305 2.8928 0.737305 3.16895C0.737305 3.44509 1.00593 3.66895 1.3373 3.66895H3.1748V5.56895C3.1748 5.90032 3.39866 6.16895 3.6748 6.16895C3.95095 6.16895 4.1748 5.90032 4.1748 5.56895V3.66895H6.1373C6.46868 3.66895 6.73731 3.44509 6.7373 3.16895C6.7373 2.8928 6.46868 2.66895 6.1373 2.66895H4.1748V0.768945Z"
        fill="#00B2AD"
      />
    </svg>
  )
}

export default React.memo(RateAiIcon)
